import React from 'react';
import {ReactComponent as ChevronIcon} from "@assets/icons/chevron.svg";
import {ReactComponent as LogoutIcon} from "@assets/icons/logout.svg";
import useAuth from "../hooks/use-auth";
import useModalWithData from "@common/hooks/use-modal-with-data";
import {ModalIds} from "@common/models/enums/modal-ids.enum";
import {LogoutConfirmModalData} from "../../../layout/components/logout-confirm-modal";

const LogoutButton: React.FC = () => {
  const {logout} = useAuth();
  const {showModal: showLogoutModal} = useModalWithData<LogoutConfirmModalData>(ModalIds.LOGOUT_CONFIRM);

  const handleLogoutClick = () => showLogoutModal({onConfirm: logout});

  return (
      <button
          onClick={handleLogoutClick}
          className="w-full flex items-center p-2 text-on-surface transition-colors duration-200"
      >
        <LogoutIcon className="mr-3"/>
        <span className="font-semibold text-[1rem] mr-auto">Wyloguj</span>
        <ChevronIcon className="text-on-surface/40"/>
      </button>
  );
};

export default LogoutButton;
